<template>
    <div>
        <div class="details_div">
            <div class="details_title">{{title}}</div>
            <div class="details_time">{{time}}</div>
        </div>
        <div class="details_content" v-html="content"></div>
    </div>
</template>

<script>
import autho from '../autho/autho.js'
var that;
export default {
    data(){
        return {
            title:'',
            time:'',
            content:''
        }
    },
    mounted(){
        that = this;
        let id = that.$route.query.id
        that.requestFun(id)
    },
    methods:{
        async requestFun(id){
            const res = await autho.request('token','post','/gzhWxApiController/getNoticeInfo',{id:id})
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.title = _data.title;
                that.time = _data.createtime;
                that.content = _data.content;
            })
        }
    }
}
</script>


<style scoped>
.details_div {
    border-bottom: 1px solid #ccc;
    padding: 0.15rem;
}
.details_title {
    font-size: 0.2rem;
}
.details_time {
    font-size: 0.12rem;
    color: #cdcdcd;
    margin-top: 0.15rem;
}
.details_content {
    padding: 0.15rem;
    text-indent: 2em;
    font-size: 0.14rem;
    line-height: 0.25rem;
}
</style>